import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKIcons,
  DKCheckMark,
  showLoader,
  removeLoader,
  showToast,
  TOAST_TYPE,
  showAlert,
  DKSpinner
} from "deskera-ui-library";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import ActivityManager from "../../activity/ActivityManager";
import Table from "../../../services/table";
import ActivityPopup from "../../activity/ActivityPopup";
import Utility from "../../../utility/Utility";

export default class ActivityPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: [],
      activityTodayList: [],
      activityFutureList: [],
      activityPastList: [],
      activityType: [],
      contactList: [],
      orgnizationList: [],
      dataList: [],
      formFields: [],
      activitiesAvailable: false,
      showActivityPopUp: false,
      isEdit: false,
      activityId: null,
      activityTodayPendingCount: 0,
      activityFuturePendingCount: 0,
      activityPastPendingCount: 0,
      isOpen: [true, true, true],
      isLoading: true
    };
  }

  componentDidMount() {
    this.initalCall();
  }

  render() {
    return (
      <div
        className="p-h-xl parent-width column  border-box bg-white border-radius-s "
        style={{ minWidth: 350, maxHeight: 780, overflow: "auto" }}
      >
        <div
          className="bg-white pt-xl pb-l parent-width border-box"
        // style={{ position: "fixed", width: "calc(100% - 868px)" }}
        >
          <div className="row  justify-content-between parent-width">
            <div className="column">
              <DKLabel text="Activities" className="fw-m fs-l" />
              {!this.state.isLoading && this.state.activitiesAvailable && (
                <DKLabel
                  text="Schedule activities with your contact to progress"
                  className="text-gray mt-xs"
                />
              )}
            </div>
            {this.state.activitiesAvailable && (
              <DKButton
                title="+ New Activity"
                className="bg-app text-white fw-m "
                onClick={() => {
                  this.showActivityForm();
                }}
              />
            )}
          </div>
        </div>
        {!this.state.isLoading && !this.state.activitiesAvailable && this.getNoActivityView()}
        {this.state.isLoading && !this.state.activitiesAvailable &&
          <div className="parent-width column align-items-center justify-content-center parent-height mt-xxl pt-xxl mb-xxl pb-xxl" style={{ minHeight: 210 }}>
            <DKSpinner title='Loading data...' />
          </div>
        }
        <div className="parent-width mb-xxl">
          {this.state.activitiesAvailable &&
            this.getListOfActivities(
              "Today's Activities",
              this.state.activityTodayPendingCount,
              this.state.activityTodayList.length,
              this.state.activityTodayList
            )}
          {this.state.activitiesAvailable &&
            this.getListOfActivities(
              "Future Activities",
              this.state.activityFuturePendingCount,
              this.state.activityFutureList.length,
              this.state.activityFutureList
            )}
          {this.state.activitiesAvailable &&
            this.getListOfActivities(
              "Past Activities",
              this.state.activityPastPendingCount,
              this.state.activityPastList.length,
              this.state.activityPastList
            )}
        </div>
        {this.state.showActivityPopUp && (
          <ActivityPopup
            isEdit={this.state.isEdit}
            dataList={this.state.dataList}
            formFields={this.state.formFields}
            onSubmit={(data) => {
              this.saveActivity(data);
            }}
            onCancel={() => this.hideActivityForm()}
          />
        )}
      </div>
    );
  }

  getNoActivityView() {
    return (
      <div className=" parent-width column align-items-center justify-content-center parent-height mt-xxl pt-xxl">
        {/* <img
          src={ic_no_activity}
          alt=""
          style={{ width: "50%", opacity: 0.6 }}
        /> */}
        <div style={{ fontSize: 80 }}>⏰</div>
        <DKLabel text="No activity created!" className=" fw-m fs-xl mt-s" />
        <DKLabel
          text="Schedule activities with your candidate<br/>to progress"
          className=" fs-m mt-r text-gray text-align-center"
        />
        {/* Note : will use in future 
        <DKButton
          title="+ Create New Activity"
          className="bg-app text-white fw-m mt-l"
          onClick={() => {
            this.showActivityForm();
          }}
        /> */}
      </div>
    );
  }

  getListOfActivities(title, pendingCnt, totalCnt, activities) {
    return (
      <div
        className="parent-width border-m border-radius-m mt-l column overflow-hidden"
        style={{ overflow: "hidden" }}
      >
        <div
          className="parent-width border-box p-r bg-gray1 column cursor-hand"
          onClick={() => this.setToggleActivity(title)}
        >
          <DKLabel text={`${title} (${totalCnt})`} className="fw-m fs-m" />
          {pendingCnt > 0 && (
            <DKLabel
              text={`${pendingCnt} pending activies`}
              className="bg-chip-red text-red
             mt-s display-block p-v-xs p-h-s border-radius-r"
            />
          )}
        </div>
        {activities && this.getToggleActivity(title) && this.state.isOpen && (
          <div className="column parent-width">
            {activities.map((obj) => {
              return this.getActivityRow(obj);
            })}
          </div>
        )}
      </div>
    );
  }
  getActivityRow(activity) {
    return (
      <div className="row p-v-s p-h-r justify-content-between">
        <div className="row align-items-starts parent-width">
          <DKCheckMark
            isSelected={activity.status}
            className="cursor-hand"
            onClick={() => {
              this.onUpdateStatus(activity.id, !activity.status);
            }}
          />
          <div className="column ml-r">
            <div className="row">
              <DKLabel text={activity.name} className="fw-m" />
              <DKLabel
                text={ActivityManager.getActivityType(
                  activity.activity_type[0]
                )}
                className={
                  "ml-r p-h-s p-v-xs border-radius-s " +
                  ActivityManager.getActivityTypeColor(
                    activity.activity_type[0]
                  )
                }
              />
            </div>
            <DKLabel
              text={new Date(activity.start_date).toDateString()}
              className="text-gray mt-xs"
            />
          </div>
        </div>
        <div className="row justify-content-end">
          <DKButton
            icon={DKIcons.ic_edit}
            onClick={() => {
              this.onEditForm(activity);
            }}
          />
          <DKButton
            icon={DKIcons.ic_delete}
            onClick={() => {
              this.getDeleteConfirmation(activity);
            }}
          />
        </div>
      </div>
    );
  }

  initalCall = () => {
    /////////// Activity //////////////
    let req = { pageNo: 1, pageSize: 10, q: "" };
    Table.getRecordsByPage(
      req,
      ActivityManager.getQuery("todayQuery", this.props.id),
      TableManger.getTableId(TABLES.ACTIVITY)
    )
      .then((res) => {
        if (res && res.data.length > 0) {
          let todayActivityList = ActivityManager.activityData(res.data);
          this.setState(
            {
              activityTodayList: todayActivityList.activitylist,
              activityTodayPendingCount: todayActivityList.pendingCount,
            },
            () => this.checkEmptyState()
          );
        } else {
          this.setState({ activityTodayList: [], activityTodayPendingCount: 0 }, () =>
            this.checkEmptyState()
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    Table.getRecordsByPage(
      req,
      ActivityManager.getQuery("pastQuery", this.props.id),
      TableManger.getTableId(TABLES.ACTIVITY)
    )
      .then((res) => {
        if (res && res.data.length > 0) {
          let pastActivityList = ActivityManager.activityData(res.data);
          this.setState(
            {
              activityPastList: pastActivityList.activitylist,
              activityPastPendingCount: pastActivityList.pendingCount,
            },
            () => this.checkEmptyState()
          );
        } else {
          this.setState({ activityPastList: [], activityPastPendingCount: 0 }, () => this.checkEmptyState());
        }
      })
      .catch((err) => {
        console.log(err);
      });

    Table.getRecordsByPage(
      req,
      ActivityManager.getQuery("futureQuery", this.props.id),
      TableManger.getTableId(TABLES.ACTIVITY)
    )
      .then((res) => {
        if (res && res.data.length > 0) {
          let futureActivityList = ActivityManager.activityData(res.data);
          this.setState(
            {
              activityFutureList: futureActivityList.activitylist,
              activityFuturePendingCount: futureActivityList.pendingCount,
            },
            () => this.checkEmptyState()
          );
        } else {
          this.setState({ activityFutureList: [], activityFuturePendingCount: 0 }, () =>
            this.checkEmptyState()
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    //////////////////DEAL///////////////////////
    Table.getRecords(TableManger.getTableId(TABLES.CANDIDATE)).then((res) => {
      if (res && res.length > 0) {
        let dealList = ActivityManager.contactData(res);
        this.setState({ dealList: dealList });
      }
    });

    //////////////////CONTACT PERSON///////////////////////

    Table.getRecordsByPage(
      null,
      ActivityManager.getQuery("personQuery", this.props.id),
      TableManger.getTableId(TABLES.CANDIDATE)
    )
      .then((res) => {
        if (res && res.data.length > 0) {
          let personList = ActivityManager.contactData(res.data);
          this.setState({ contactList: personList });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    //////////////////ORGANIZATION///////////////////////

    Table.getRecordsByPage(
      null,
      ActivityManager.getQuery("orgQuery", this.props.id),
      TableManger.getTableId(TABLES.CANDIDATE)
    )
      .then((res) => {
        if (res && res.data.length > 0) {
          let organizationList = ActivityManager.contactData(res.data);
          this.setState({ orgnizationList: organizationList });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  checkEmptyState = () => {
    if (
      this.state.activityTodayList.length === 0 &&
      this.state.activityFutureList.length === 0 &&
      this.state.activityPastList.length === 0
    ) {
      this.setState({ activitiesAvailable: false,isLoading: false });
    } else {
      this.setState({ activitiesAvailable: true,isLoading: true });
    }
  };

  activityFormBuild = (data) => {
    let activityTypeData = [];
    let contact,
      deal,
      orgnization,
      listData = [];
    let activityType = TableManger.getColumn(
      TABLES.ACTIVITY,
      COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE
    );
    activityType.options.forEach((option) => {
      activityTypeData.push({ title: option.name, value: option.id });
    });
    activityTypeData = this.changeTypePosition(activityTypeData);
    contact = this.state.contactList.map((option) => option.name);
    deal = this.state.dealList.map((option) => option.name);
    orgnization = this.state.orgnizationList.map((option) => option.name);
    listData["activityType"] = activityTypeData;
    listData["contacts"] = contact;
    listData["deals"] = deal;
    listData["orgnizations"] = orgnization;
    let columns = TableManger.getTableColumns(TABLES.ACTIVITY);
    let fields = this.getCommonFields(columns);
    this.setState({ dataList: listData, formFields: fields }, () => {
      if (this.state.isEdit) {
        this.editFormBuild(data);
      }
      this.setState({ showActivityPopUp: true });
    });
  };

  changeTypePosition = (activityType) => {
    let index = activityType.findIndex((type) => type.title === "Task");
    let firstPlaace = activityType[index];
    activityType.splice(index, 1);
    activityType.splice(0, 0, firstPlaace);
    return activityType;
  };

  showActivityForm = () => {
    this.activityFormBuild();
  };

  hideActivityForm = () => {
    this.setState({
      showActivityPopUp: false,
      isEdit: false,
      activityId: null,
    });
  };

  getCommonFields = (columns) => {
    let fields = [];
    columns.forEach((column) => {
      if (column.editable) {
        let value = "";
        if (column.columnCode === COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE) {
          value = 3;
          this.setState({ activityType: column.options });
        }
        if (
          column.columnCode === COLUMN_CODE.ACTIVITY.STATUS ||
          column.columnCode === COLUMN_CODE.ACTIVITY.SEND_INVITATION ||
          column.columnCode === COLUMN_CODE.ACTIVITY.SEND_CONTACTS_INVITATION
        ) {
          value = false;
        }
        if (
          column.columnCode === COLUMN_CODE.ACTIVITY.LINKED_TO &&
          this.props.module === "DEAL"
        ) {
          let index = this.state.dealList.findIndex(
            (deal) => deal.id === this.props.id
          );
          value = [index];
        }
        fields.push({
          key: column.columnCode,
          title: column.name,
          type: column.type,
          value: value,
          required: column.required,
        });
      }
    });
    return fields;
  };

  saveActivity = (data) => {
    if (Utility.isEmpty(data)) {
      return;
    }
    data = this.updateActivityType(data);
    data = this.updateDealId(data);
    data = this.updateContactId(data);
    data = this.updateOrganizationId(data);
    let request = ActivityManager.createRequestJson(data);
    if (Utility.isEmpty(this.state.activityId)) {
      this.onAdd(request);
    } else {
      this.onUpdate(request);
    }
  };

  onAdd = (request) => {
    showLoader("Adding activity...");
    Table.addRecord({ cells: request }, ActivityManager.getTableId())
      .finally(() => removeLoader())
      .then((response) => {
        this.initalCall();
        showToast("Activity Added Successfully.", TOAST_TYPE.SUCCESS);
        this.hideActivityForm();
      });
  };

  onUpdate = (request) => {
    showLoader("Updating activity...");
    Table.updateRecord(
      request,
      this.state.activityId,
      ActivityManager.getTableId()
    )
      .finally(() => removeLoader())
      .then((response) => {
        this.initalCall();
        showToast("Activity Updated Successfully.", TOAST_TYPE.SUCCESS);
        this.hideActivityForm();
      });
  };

  updateActivityType = (data, isEdit = false) => {
    let fieldData = data.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.ACTIVTY_TYPE
    );
    if (isEdit) {
      let id = this.state.activityType.findIndex(
        (field) => field.id === fieldData.value[0]
      );
      fieldData.value = id;
    } else {
      fieldData.value = [this.state.activityType[fieldData.value].id];
    }
    return data;
  };

  updateDealId = (data, isEdit = false) => {
    let fieldData = data.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.LINKED_TO
    );
    if (Utility.isEmpty(fieldData.value)) {
      return data;
    }
    if (isEdit) {
      let value = this.state.dealList.findIndex(
        (field) => field.id === fieldData.value[0]
      );
      fieldData.value = [value];
    } else {
      fieldData.value = [this.state.dealList[fieldData.value["0"]].id];
    }
    return data;
  };

  updateContactId = (data, isEdit = false) => {
    let fieldData = data.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.CONTACT_IDS
    );
    if (Utility.isEmpty(fieldData.value)) {
      return data;
    }
    let ids = [];
    for (let index = 0; index < fieldData.value.length; index++) {
      if (isEdit) {
        let id = this.state.contactList.findIndex(
          (field) => field.id === fieldData.value[index]
        );
        ids.push(id);
      } else {
        ids.push(this.state.contactList[fieldData.value[index]].id);
      }
    }
    fieldData.value = ids;
    return data;
  };

  updateOrganizationId = (data, isEdit = false) => {
    let fieldData = data.find(
      (field) => field.key === COLUMN_CODE.ACTIVITY.ORGANIZATION_IDS
    );
    if (Utility.isEmpty(fieldData.value)) {
      return data;
    }
    let ids = [];
    for (let index = 0; index < fieldData.value.length; index++) {
      if (isEdit) {
        let id = this.state.orgnizationList.findIndex(
          (field) => field.id === fieldData.value[index]
        );
        ids.push(id);
      } else {
        ids.push(this.state.orgnizationList[fieldData.value[index]].id);
      }
    }
    fieldData.value = ids;
    return data;
  };

  onDelete = (id) => {
    Table.deleteRecord(id, TableManger.getTableId(TABLES.ACTIVITY)).then(
      (res) => {
        this.initalCall();
        showToast("Activity Deleted Successfully.", TOAST_TYPE.SUCCESS);
      }
    );
  };

  onUpdateStatus = (id, status) => {
    let data = {
      [ActivityManager.getColumnId(COLUMN_CODE.ACTIVITY.STATUS)]: status,
    };
    Table.updateRecord(data, id, TableManger.getTableId(TABLES.ACTIVITY)).then(
      (res) => {
        this.initalCall();
        showToast("Activity Updated Successfully.", TOAST_TYPE.SUCCESS);
      }
    );
  };

  onEditForm = (data) => {
    this.setState({ isEdit: true, activityId: data.id });
    this.activityFormBuild(data);
  };

  editFormBuild = (data) => {
    let defaultForm = [...this.state.formFields];
    defaultForm.forEach((value, index) => {
      defaultForm[index].value = data[defaultForm[index].key];
    });
    defaultForm = this.updateActivityType(defaultForm, true);
    defaultForm = this.updateDealId(defaultForm, true);
    defaultForm = this.updateContactId(defaultForm, true);
    defaultForm = this.updateOrganizationId(defaultForm, true);
    this.setState({ showActivityPopUp: true, formFields: defaultForm });
  };

  setToggleActivity = (activity) => {
    switch (activity) {
      case "Today's Activities":
        this.toggleActivity(0);
        break;
      case "Future Activities":
        this.toggleActivity(1);
        break;
      case "Past Activities":
        this.toggleActivity(2);
        break;
      default:
        this.toggleActivity(0);
    }
  };

  toggleActivity = (index) => {
    let activityToggle = this.state.isOpen;
    activityToggle[index] = !activityToggle[index];
    this.setState({ isOpen: activityToggle });
  };

  getToggleActivity = (activity) => {
    switch (activity) {
      case "Today's Activities":
        return this.gettoggleActivity(0);
      case "Future Activities":
        return this.gettoggleActivity(1);
      case "Past Activities":
        return this.gettoggleActivity(2);
      default:
        return this.gettoggleActivity(0);
    }
  };

  gettoggleActivity = (index) => {
    let activityToggle = this.state.isOpen;
    return activityToggle[index];
  };

  getDeleteConfirmation = (activity) => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => this.onDelete(activity.id),
      },
    ];
    showAlert(
      "Delete Activity?",
      "Deleting this activity will delete it permanently you will not be able to restore it.",
      buttons
    );
  };
}
